var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.gameType === 'ROULETTE')?_c('RouletteBoard',{ref:"card_board",attrs:{"gameType":_vm.gameType,"gameState":_vm.gameState}}):_c('CardBoard',{ref:"card_board",attrs:{"gameType":_vm.gameType,"gameState":_vm.gameState}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }